import Multiple from './multiple-choice'
export default Multiple
